<script src="../../../../../environment/settings/mizaem_kz.js"></script>
<template>
    <div @click="toProfile()" class="credit-score-linear">
        <v-progress-linear :value="progress" height="35" :color="color">
            <span class="subtitle-2 font-weight-bold">{{$t('credit_score.your_score', { score: creditScore })}}</span>
        </v-progress-linear>
    </div>
</template>

<script>
    import creditScoreService from "@/app/client/profile/shared/services/creditScoreService";

    export default {
        name: 'CreditScoreLinear',
        data() {
            return {

            }
        },
        computed: {
            user() {
                return this.$store.getters.AUTH_USER;
            },
            creditScore() {
                return this.user && this.user.credit_score
                    ? this.user.credit_score
                    : 0;
            },
            progress() {
                return this.user && this.user.credit_score
                    ? Math.floor(this.user.credit_score / 999 * 100)
                    : 0;
            },
            color() {
                const status = creditScoreService.status(this.creditScore);
                let color;
                switch (status) {
                    case "very_low":
                        color = 'red accent-2';
                        break;
                    case "low":
                    case 'normal':
                        color = 'yellow accent-3';
                        break;
                    default:
                        color = 'green accent-3';
                        break;
                }

                return color;
            }
        },
        methods: {
            toProfile() {
                this.$router.push({ name: 'PanelProfile' });
            }
        }
    }
</script>


<style>
</style>
